import Backbone from 'backbone'
import template from './form-logician-editor.hbs'
import formLogician from 'scoreboard/forms/edit/form-logician'
import FormView from 'scoreboard/components/form-view'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

const FormLogicianEditor = Backbone.View.extend({

	tagName: 'form',

	className: 'form-logician-editor',

	events: {
		'click .button-primary': 'showRemainingCollapsedFields'
	},

	/**
	 * @param options.currentWidget {Widget} the current widget containing the
	 * form logician
	 */
	initialize: function(options={}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			test: this.test.bind(this)
		})
		this.statements = this.options.statements ?? []
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.logician = formLogician({
			formView: this.formView,
			model: this.model,
			pageOrder: _.map(this.model.get('pages'), p => p.id),
			statements: this.options.statements,
			allowedActionTypes: this.options?.allowedActionTypes,
			currentWidget: this.options.currentWidget
		})

		this.$('.dialog-body-content').append(this.logician.el)
		this.logician.render()

		this.formView.start()
		return this
	},

	context: function() {
		const titleMsgCode = _.isNil(this.options.statements) ?
			'common.add2' : 'common.edit2'
		return { title: i18n.get(titleMsgCode, this.options.title) }
	},

	test: function() {
		const test = this.logician?.test()
		if (!test) {
			const data = this.logician?.readFromDom()
			if (!_.some(data, s => !_.isEmpty(s.consequences))) {
				return i18n.get('forms.formLogician.actionRequired')
			}
			// #54608 if any of the consequences are 'send-alert', check that
			// the alertMessage and alertRecipients have been specified
			return this.testSendAlertActions(data)
		}
		return test
	},

	testSendAlertActions: function(data) {
		// #54608 if any of the consequences are 'send-alert', check that
		// the alertMessage and alertRecipients have been specified
		const alertConsequences = _.filter(data, s =>
			s.consequences.some(c => c.type === 'send-alert'))
		// #58586 check if any of the consequences are send-alert actions
		// missing alert details (not just the first one)
		const alertDetailMissing = _.some(alertConsequences, s =>
			s.consequences.some(c => c.type == 'send-alert' &&
				(_.isEmpty(c.alertMessage) || _.isEmpty(c.alertRecipients))
			)
		)
		if (alertDetailMissing) {
			return i18n.get('forms.actions.action.send-alert.alertDetails.required')
		}
	},

	submit: function() {
		this.trigger('done', this.logician.readFromDom())
	},

	showRemainingCollapsedFields: function() {
		this.logician.showRemainingCollapsedFields()
	},

	autoRemove: true
})

export default FormLogicianEditor

FormLogicianEditor.__filename__ = 'forms/edit/form-logician-editor.js'
